module.exports = __webpack_public_path__ + "static/laptop-9375ca1102c1a398b0ea65c22a6e1949.jpg";